export default __webpack_public_path__ + "static/media/project9.ddefd427.jpg";